/**
 * @generated SignedSource<<c7e1b44786cd527791f0797563d6f07e>>
 * @relayHash 415fe40c7138daad897bc69bc2e432c8
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a1eaead1dc8c404dd634c985654b6484dd0628c550f6d54f56df8d5f77c51fe0

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GuildMembersScreenQuery$variables = {
  id: string;
};
export type GuildMembersScreenQuery$data = {
  readonly nodeBySlugId: {
    readonly __typename: "Guild";
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"GuildMembersEditorsSection_guild" | "GuildMembersNonOrganizersSection_guild" | "GuildMembersOrganizersSection_guild" | "GuildMembersPresentersSection_guild" | "GuildMetadata_guild">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
};
export type GuildMembersScreenQuery = {
  response: GuildMembersScreenQuery$data;
  variables: GuildMembersScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slugId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "kind": "Literal",
  "name": "first",
  "value": 3
},
v7 = [
  (v6/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emailMd5",
  "storageKey": null
},
v12 = {
  "kind": "Literal",
  "name": "dpr",
  "value": 3
},
v13 = {
  "kind": "Literal",
  "name": "fit",
  "value": "cover"
},
v14 = {
  "kind": "Literal",
  "name": "fo",
  "value": "auto"
},
v15 = {
  "kind": "Literal",
  "name": "h",
  "value": 100
},
v16 = {
  "kind": "Literal",
  "name": "w",
  "value": 100
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "primaryPhoto",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "fields": [
            (v12/*: any*/),
            (v13/*: any*/),
            (v14/*: any*/),
            (v15/*: any*/),
            (v16/*: any*/)
          ],
          "kind": "ObjectValue",
          "name": "transform"
        }
      ],
      "kind": "ScalarField",
      "name": "transformUrl",
      "storageKey": "transformUrl(transform:{\"dpr\":3,\"fit\":\"cover\",\"fo\":\"auto\",\"h\":100,\"w\":100})"
    },
    (v5/*: any*/)
  ],
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": [
    {
      "fields": [
        (v12/*: any*/),
        (v14/*: any*/),
        (v15/*: any*/),
        (v16/*: any*/)
      ],
      "kind": "ObjectValue",
      "name": "transform"
    }
  ],
  "kind": "ScalarField",
  "name": "defaultAvatarUrl",
  "storageKey": "defaultAvatarUrl(transform:{\"dpr\":3,\"fo\":\"auto\",\"h\":100,\"w\":100})"
},
v19 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "GuildMembershipsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GuildMembership",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "membershipLevel",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Guild",
            "kind": "LinkedField",
            "name": "guild",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v3/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "primaryPhoto",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "fields": [
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/)
                        ],
                        "kind": "ObjectValue",
                        "name": "transform"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "transformUrl",
                    "storageKey": "transformUrl(transform:{\"dpr\":3,\"fit\":\"cover\",\"h\":100,\"w\":100})"
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v22 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "UsersEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          (v4/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bio",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isMe",
            "storageKey": null
          },
          (v11/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Image",
            "kind": "LinkedField",
            "name": "backgroundPhoto",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "transform",
                    "value": {
                      "dpr": 3,
                      "fit": "cover",
                      "fo": "auto",
                      "h": 167,
                      "w": 500
                    }
                  }
                ],
                "kind": "ScalarField",
                "name": "transformUrl",
                "storageKey": "transformUrl(transform:{\"dpr\":3,\"fit\":\"cover\",\"fo\":\"auto\",\"h\":167,\"w\":500})"
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "organizerGuildMemberships",
            "args": [
              {
                "kind": "Literal",
                "name": "condition",
                "value": {
                  "membershipLevel": "ORGANIZER"
                }
              },
              (v6/*: any*/)
            ],
            "concreteType": "GuildMembershipsConnection",
            "kind": "LinkedField",
            "name": "guildMemberships",
            "plural": false,
            "selections": (v19/*: any*/),
            "storageKey": "guildMemberships(condition:{\"membershipLevel\":\"ORGANIZER\"},first:3)"
          },
          {
            "alias": "editorGuildMemberships",
            "args": [
              {
                "kind": "Literal",
                "name": "condition",
                "value": {
                  "membershipLevel": "EDITOR"
                }
              },
              (v6/*: any*/)
            ],
            "concreteType": "GuildMembershipsConnection",
            "kind": "LinkedField",
            "name": "guildMemberships",
            "plural": false,
            "selections": (v19/*: any*/),
            "storageKey": "guildMemberships(condition:{\"membershipLevel\":\"EDITOR\"},first:3)"
          },
          (v5/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      (v20/*: any*/)
    ],
    "storageKey": null
  },
  (v21/*: any*/)
],
v23 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 12
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GuildMembersScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "nodeBySlugId",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "GuildMetadata_guild"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "GuildMembersOrganizersSection_guild"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "GuildMembersEditorsSection_guild"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "GuildMembersPresentersSection_guild"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "GuildMembersNonOrganizersSection_guild"
              }
            ],
            "type": "Guild",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GuildMembersScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "nodeBySlugId",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "backgroundPhoto",
                "plural": false,
                "selections": [
                  {
                    "alias": "coverUrl",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "transform",
                        "value": {
                          "dpr": 1,
                          "fit": "cover",
                          "fo": "auto",
                          "h": 600,
                          "w": 1200
                        }
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "transformUrl",
                    "storageKey": "transformUrl(transform:{\"dpr\":1,\"fit\":\"cover\",\"fo\":\"auto\",\"h\":600,\"w\":1200})"
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": "defaultCoverUrl",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "transform",
                    "value": {
                      "dpr": 1,
                      "fit": "cover",
                      "h": 600,
                      "w": 1200
                    }
                  }
                ],
                "kind": "ScalarField",
                "name": "defaultBackgroundUrl",
                "storageKey": "defaultBackgroundUrl(transform:{\"dpr\":1,\"fit\":\"cover\",\"h\":600,\"w\":1200})"
              },
              {
                "alias": null,
                "args": (v7/*: any*/),
                "concreteType": "UsersConnection",
                "kind": "LinkedField",
                "name": "organizers",
                "plural": false,
                "selections": (v22/*: any*/),
                "storageKey": "organizers(first:3)"
              },
              {
                "alias": null,
                "args": (v7/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "GuildMembersOrganizersSection_guild_organizers",
                "kind": "LinkedHandle",
                "name": "organizers"
              },
              (v5/*: any*/),
              {
                "alias": null,
                "args": (v7/*: any*/),
                "concreteType": "UsersConnection",
                "kind": "LinkedField",
                "name": "editors",
                "plural": false,
                "selections": (v22/*: any*/),
                "storageKey": "editors(first:3)"
              },
              {
                "alias": null,
                "args": (v7/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "GuildMembersEditorsSection_guild_editors",
                "kind": "LinkedHandle",
                "name": "editors"
              },
              {
                "alias": null,
                "args": (v23/*: any*/),
                "concreteType": "UsersConnection",
                "kind": "LinkedField",
                "name": "presenters",
                "plural": false,
                "selections": (v22/*: any*/),
                "storageKey": "presenters(first:12)"
              },
              {
                "alias": null,
                "args": (v23/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "GuildMembersPresentersSection_guild_presenters",
                "kind": "LinkedHandle",
                "name": "presenters"
              },
              {
                "alias": null,
                "args": (v23/*: any*/),
                "concreteType": "UsersConnection",
                "kind": "LinkedField",
                "name": "members",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UsersEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v8/*: any*/),
                          (v11/*: any*/),
                          (v17/*: any*/),
                          (v18/*: any*/),
                          (v5/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v20/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v21/*: any*/)
                ],
                "storageKey": "members(first:12)"
              },
              {
                "alias": null,
                "args": (v23/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "GuildMembersNonOrganizersSection_guild_members",
                "kind": "LinkedHandle",
                "name": "members"
              }
            ],
            "type": "Guild",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v5/*: any*/)
            ],
            "type": "Node",
            "abstractKey": "__isNode"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "a1eaead1dc8c404dd634c985654b6484dd0628c550f6d54f56df8d5f77c51fe0",
    "metadata": {},
    "name": "GuildMembersScreenQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "9d329f38e82c6e0a13979eee61c62235";

export default node;
